var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useMemo, useState } from "react";
import { SimpleForm, useGetList, useInfiniteGetList } from "react-admin";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useTranslation } from "react-i18next";
import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, Typography, } from "@mui/material";
import TextField from "@mui/material/TextField";
import { sortFunction } from "./utils";
import { EEnableCheckableLists, translateFromPresentation, } from "@sequentech/ui-core";
import { filterCandidateByCheckableLists } from "@/services/CandidatesFilter";
import { createTree, getContestMatches } from "@/services/AreaService";
var votingChannels = [
    { id: "PAPER", name: "PAPER" },
    { id: "POSTAL", name: "POSTAL" },
];
var numbers = /^[0-9]+$/;
export var EditTallySheet = function (props) {
    var tallySheet = props.tallySheet, contest = props.contest, doCreatedTalySheet = props.doCreatedTalySheet, submitRef = props.submitRef;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var _b = useState([]), areasList = _b[0], setAreasList = _b[1];
    var _c = React.useState(null), channel = _c[0], setChannel = _c[1];
    var _d = useState({
        area_id: "",
        contest_id: "-",
        invalid_votes: {},
        candidate_results: {},
    }), results = _d[0], setResults = _d[1];
    var _e = useState({}), invalids = _e[0], setInvalids = _e[1];
    var _f = useState([]), candidatesResults = _f[0], setCandidatesResults = _f[1];
    var _g = useState(null), areaNameFilter = _g[0], setAreaNameFilter = _g[1];
    var _h = useState([]), areaIds = _h[0], setAreaIds = _h[1];
    var areaContests = useGetList("sequent_backend_area_contest", {
        filter: {
            tenant_id: contest.tenant_id,
            election_event_id: contest.election_event_id,
            contest_id: contest.id,
        },
        pagination: {
            perPage: 10000,
            page: 1,
        },
    }).data;
    var allAreas = useGetList("sequent_backend_area", {
        filter: {
            tenant_id: contest.tenant_id,
            election_event_id: contest.election_event_id,
        },
        pagination: {
            perPage: 10000,
            page: 1,
        },
    }).data;
    var _j = useGetList("sequent_backend_area", {
        filter: {
            tenant_id: contest.tenant_id,
            election_event_id: contest.election_event_id,
            name: areaNameFilter !== null && areaNameFilter !== void 0 ? areaNameFilter : "",
            id: {
                format: "hasura-raw-query",
                value: { _in: areaIds },
            },
            /*parent_id: {
                format: "hasura-raw-query",
                value: {_is_null: true},
            },*/
        },
        pagination: {
            perPage: 10000,
            page: 1,
        },
    }), areas = _j.data, refetch = _j.refetch;
    var _k = useInfiniteGetList("sequent_backend_candidate", {
        filter: {
            contest_id: contest.id,
            tenant_id: contest.tenant_id,
            election_event_id: contest.election_event_id,
        },
        pagination: { page: 1, perPage: 50 },
    }), fetchedCandidates = _k.data, hasNextPage = _k.hasNextPage, fetchNextPage = _k.fetchNextPage;
    var checkableLists = useMemo(function () {
        var _a;
        var presentation = contest.presentation;
        return (_a = presentation === null || presentation === void 0 ? void 0 : presentation.enable_checkable_lists) !== null && _a !== void 0 ? _a : EEnableCheckableLists.CANDIDATES_AND_LISTS;
    }, [contest.presentation]);
    var candidates = useMemo(function () {
        //force fetch all records
        hasNextPage && fetchNextPage();
        return fetchedCandidates === null || fetchedCandidates === void 0 ? void 0 : fetchedCandidates.pages.flatMap(function (item) { return item.data; });
    }, [fetchedCandidates]);
    var uniqueElements = function (arr) {
        var uniqueObj = {};
        var uniqueArr = [];
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var item = arr_1[_i];
            if (!uniqueObj[item]) {
                uniqueObj[item] = true;
                uniqueArr.push(item);
            }
        }
        return uniqueArr;
    };
    useEffect(function () {
        var treeNodeAreas = (allAreas !== null && allAreas !== void 0 ? allAreas : []).map(function (area) { return ({
            id: area.id,
            tenant_id: area.tenant_id,
            election_event_id: area.election_event_id,
            parent_id: area.parent_id,
        }); });
        var treeAreaContests = (areaContests !== null && areaContests !== void 0 ? areaContests : []).map(function (areaContest) { return ({
            id: areaContest.id,
            area_id: areaContest.area_id,
            contest_id: areaContest.contest_id,
        }); });
        var tree = createTree(treeNodeAreas, treeAreaContests);
        var matchedAreaContests = getContestMatches(tree, contest.id);
        var matchedAreas = matchedAreaContests.map(function (area) { return area.area_id; });
        var uniqueAreas = uniqueElements(matchedAreas);
        setAreaIds(uniqueAreas);
    }, [areaContests, allAreas]);
    useEffect(function () {
        var tallySaved = localStorage.getItem("tallySheetData");
        if ((tallySheet || tallySaved) && candidates) {
            var tallySheetTemp = tallySaved ? JSON.parse(tallySaved || "") : tallySheet;
            if (tallySheetTemp.content) {
                var contentTemp = __assign({}, tallySheetTemp.content);
                if (contentTemp.invalid_votes) {
                    var invalidsTemp = __assign({}, contentTemp.invalid_votes);
                    setInvalids(invalidsTemp);
                }
                if (contentTemp.candidate_results) {
                    var candidatesResultsTemp = [];
                    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
                        var candidate = candidates_1[_i];
                        var isValid = filterCandidateByCheckableLists(candidate, checkableLists);
                        if (!isValid) {
                            continue;
                        }
                        var candidateTemp = {
                            candidate_id: candidate.id,
                            name: translateFromPresentation(candidate, "name", i18n.language),
                        };
                        if (contentTemp.candidate_results[candidate.id]) {
                            candidateTemp.total_votes =
                                contentTemp.candidate_results[candidate.id].total_votes;
                        }
                        candidatesResultsTemp.push(candidateTemp);
                    }
                    candidatesResultsTemp.sort(sortFunction);
                    setCandidatesResults(candidatesResultsTemp);
                }
                setResults(contentTemp);
            }
            setChannel(tallySheetTemp.channel);
        }
    }, [tallySheet, candidates]);
    useEffect(function () {
        if (contest) {
            setResults(function (prev) { return (__assign(__assign({}, prev), { contest_id: contest.id })); });
        }
    }, [contest]);
    useEffect(function () {
        if (areas) {
            var areatListTemp = areas === null || areas === void 0 ? void 0 : areas.map(function (item) {
                return {
                    id: item.id,
                    label: item.name,
                };
            });
            setAreasList(areatListTemp);
        }
    }, [areas]);
    useEffect(function () {
        window.scrollTo(0, 0);
    }, []);
    useEffect(function () {
        var tallySaved = localStorage.getItem("tallySheetData");
        if (!(tallySheet || tallySaved) && candidates) {
            var candidatesTemp = [];
            for (var _i = 0, candidates_2 = candidates; _i < candidates_2.length; _i++) {
                var candidate = candidates_2[_i];
                var isValid = filterCandidateByCheckableLists(candidate, checkableLists);
                if (!isValid) {
                    continue;
                }
                var candidateTemp = {
                    candidate_id: candidate.id,
                    name: translateFromPresentation(candidate, "name", i18n.language),
                };
                candidatesTemp.push(candidateTemp);
            }
            candidatesTemp.sort(sortFunction);
            setCandidatesResults(candidatesTemp);
        }
    }, [candidates, tallySheet]);
    var recalculateTotals = function () {
        var _a, _b, _c, _d, _e;
        var newResults = __assign({}, results);
        var totalValidVotes = Math.max((_a = newResults.total_blank_votes) !== null && _a !== void 0 ? _a : 0, (_b = newResults.total_valid_votes) !== null && _b !== void 0 ? _b : 0);
        var totalVotes = totalValidVotes + ((_c = invalids === null || invalids === void 0 ? void 0 : invalids.total_invalid) !== null && _c !== void 0 ? _c : 0);
        newResults.total_valid_votes = totalValidVotes;
        newResults.total_votes = totalVotes;
        var currentTotalVotes = (_d = newResults.total_votes) !== null && _d !== void 0 ? _d : 0;
        newResults.census = Math.max((_e = newResults.census) !== null && _e !== void 0 ? _e : 0, currentTotalVotes);
        if (JSON.stringify(newResults) !== JSON.stringify(results)) {
            setResults(newResults);
        }
    };
    useEffect(recalculateTotals, [
        results,
        candidatesResults,
        results.total_blank_votes,
        results.total_valid_votes,
        invalids === null || invalids === void 0 ? void 0 : invalids.total_invalid,
        invalids,
    ]);
    var handleChange = function (event, value, reason, details) {
        // setArea(event.target.value as string)
        setResults(function (prev) { return (__assign(__assign({}, prev), { area_id: value === null || value === void 0 ? void 0 : value.id })); });
    };
    var handleTextChange = function (event) {
        setResults(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = event.target.value, _a)));
        });
    };
    var handleNumberChange = function (event) {
        if (event.target.value === "") {
            setResults(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = "", _a)));
            });
        }
        else if (event.target.value === "0") {
            setResults(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = 0, _a)));
            });
        }
        else {
            if (event.target.value.match(numbers)) {
                setResults(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = +event.target.value, _a)));
                });
            }
        }
    };
    var handleCensusChange = function (event) {
        var _a;
        var census = 0;
        if (event.target.value.match(numbers)) {
            census = Number(event.target.value);
        }
        var currentTotalVotes = (_a = results.total_votes) !== null && _a !== void 0 ? _a : 0;
        census = Math.max(census, currentTotalVotes);
        setResults(__assign(__assign({}, results), { census: census }));
    };
    var handleInvalidChange = function (event) {
        var _a, _b;
        var newInvalid = __assign({}, invalids);
        var key = event.target.name;
        if (event.target.value === "") {
            newInvalid[key] = 0;
        }
        else if (event.target.value.match(numbers)) {
            newInvalid[key] = Number(event.target.value);
        }
        newInvalid.total_invalid =
            ((_a = newInvalid.explicit_invalid) !== null && _a !== void 0 ? _a : 0) + ((_b = newInvalid.implicit_invalid) !== null && _b !== void 0 ? _b : 0);
        setInvalids(newInvalid);
    };
    var handleCandidateChange = function (event) {
        var candidateTemp = candidatesResults.find(function (item) { return item.candidate_id === event.target.id; });
        var candidateRest = candidatesResults.filter(function (item) { return item.candidate_id !== event.target.id; });
        if (candidateTemp) {
            if (!event.target.value) {
                delete candidateTemp.total_votes;
            }
            else {
                if (event.target.value.match(numbers)) {
                    candidateTemp.total_votes = +event.target.value;
                }
                else {
                    candidateTemp.total_votes = +((candidateTemp === null || candidateTemp === void 0 ? void 0 : candidateTemp.total_votes) || 0);
                }
            }
            var finalCandidates = __spreadArray(__spreadArray([], candidateRest, true), [candidateTemp], false);
            finalCandidates.sort(function (a, b) { return a.name.localeCompare(b.name); });
            setCandidatesResults(finalCandidates);
        }
    };
    var timeoutId;
    var debouncedSearchArea = function (event) {
        var value = event.target.value;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            setAreaNameFilter(value ? value.trim() : null);
            refetch();
        }, 350);
    };
    var onSubmit = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var resultsTemp, invalidsTemp, candidatesResultsTemp, _i, candidatesResults_1, candiate, candiateTemp, tallySheetData;
        return __generator(this, function (_a) {
            resultsTemp = __assign({}, results);
            invalidsTemp = __assign({}, invalids);
            candidatesResultsTemp = {};
            for (_i = 0, candidatesResults_1 = candidatesResults; _i < candidatesResults_1.length; _i++) {
                candiate = candidatesResults_1[_i];
                candiateTemp = {
                    candidate_id: candiate.candidate_id,
                    total_votes: candiate.total_votes,
                };
                candidatesResultsTemp[candiate.candidate_id] = candiateTemp;
            }
            resultsTemp.invalid_votes = invalidsTemp;
            resultsTemp.candidate_results = candidatesResultsTemp;
            tallySheetData = {
                tenant_id: contest.tenant_id,
                election_event_id: contest.election_event_id,
                election_id: contest.election_id,
                contest_id: contest.id,
                area_id: resultsTemp.area_id,
                channel: channel || "",
                content: resultsTemp,
            };
            if (tallySheet) {
                tallySheetData.id = tallySheet.id;
            }
            localStorage.setItem("tallySheetData", JSON.stringify(tallySheetData));
            if (doCreatedTalySheet) {
                doCreatedTalySheet(tallySheetData);
            }
            return [2 /*return*/];
        });
    }); };
    var currentArea = useMemo(function () { return areasList.find(function (area) { return area.id === (results === null || results === void 0 ? void 0 : results.area_id); }) || null; }, [results === null || results === void 0 ? void 0 : results.area_id, areasList]);
    return (_jsx(SimpleForm, __assign({ toolbar: false, onSubmit: onSubmit }, { children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("tallysheet.common.subtitle") }), _jsx(FormControl, __assign({ fullWidth: true, size: "small" }, { children: _jsx(Autocomplete, { sx: { width: 300 }, onChange: handleChange, options: areasList !== null && areasList !== void 0 ? areasList : [], renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: "Search Area", onChange: debouncedSearchArea, value: areaNameFilter }))); }, value: currentArea, isOptionEqualToValue: function (a, b) { return a.id === b.id; } }) })), _jsxs(FormControl, __assign({ fullWidth: true, size: "small" }, { children: [_jsx(InputLabel, { children: t("tallysheet.label.channel") }), _jsx(Select, __assign({ name: "channel", value: channel || "", label: t("tallysheet.label.channel"), onChange: function (e) { return setChannel(e.target.value); }, required: true }, { children: votingChannels.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.name }), item.id)); }) }))] })), _jsx(PageHeaderStyles.Wrapper, { children: _jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.data") }) }), _jsx(TextField, { label: t("tallysheet.label.contest_id"), name: "constest_id", value: results.contest_id, onChange: handleTextChange, size: "small", style: { display: "none" }, required: true }), _jsx(TextField, { label: t("tallysheet.label.total_votes"), name: "total_votes", value: typeof results.total_votes === "number" ? results.total_votes : "", onChange: handleNumberChange, size: "small", required: true, disabled: true }), _jsx(TextField, { label: t("tallysheet.label.total_valid_votes"), name: "total_valid_votes", value: typeof results.total_valid_votes === "number"
                        ? results.total_valid_votes
                        : "", onChange: handleNumberChange, size: "small", required: true }), _jsxs(Box, __assign({ sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                    } }, { children: [_jsx(TextField, { label: t("tallysheet.label.total_invalid"), name: "total_invalid", value: typeof invalids.total_invalid === "number" ? invalids.total_invalid : "", onChange: handleInvalidChange, size: "small", required: true, disabled: true }), _jsx(TextField, { label: t("tallysheet.label.implicit_invalid"), name: "implicit_invalid", value: typeof invalids.implicit_invalid === "number"
                                ? invalids.implicit_invalid
                                : "", onChange: handleInvalidChange, size: "small", required: true }), _jsx(TextField, { label: t("tallysheet.label.explicit_invalid"), name: "explicit_invalid", value: typeof invalids.explicit_invalid === "number"
                                ? invalids.explicit_invalid
                                : "", onChange: handleInvalidChange, size: "small", required: true })] })), _jsx(TextField, { label: t("tallysheet.label.total_blank_votes"), name: "total_blank_votes", value: typeof results.total_blank_votes === "number"
                        ? results.total_blank_votes
                        : "", onChange: handleNumberChange, size: "small", required: true }), _jsx(TextField, { label: t("tallysheet.label.census"), name: "census", value: typeof results.census === "number" ? results.census : "", onChange: handleCensusChange, size: "small", required: true }), _jsx(PageHeaderStyles.Wrapper, { children: _jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.candidates") }) }), candidatesResults.map(function (candidate) { return (_jsxs(Box, __assign({ sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                    } }, { children: [_jsx(Typography, __assign({ variant: "body1", sx: { width: "50%" } }, { children: candidate.name })), _jsx(TextField, { id: candidate.candidate_id, label: t("tallysheet.label.total_votes"), name: "total_votes", value: candidate.total_votes, onChange: handleCandidateChange, size: "small", required: true })] }), candidate.candidate_id)); }), _jsx("button", { ref: submitRef, type: "submit", style: { display: "none" } })] }) })));
};
